import type { Order } from "@/model/backend/order"

import { $paymentMethod, $shippingMethod } from "@/model/display-names"

export { $payType, $gender, $shippingMethod, $paymentMethod, $articleUnit } from "@/model/display-names"

export function $uploadType(value: string | undefined) {
    switch (value) {
        case "prescription":
            return "Rezept"
        case "card":
            return "Versichertenkarte"
        case "id":
            return "Personalausweis"
        case "card_front":
            return "Versichertenkarte (Vorderseite)"
        case "card_back":
            return "Versichertenkarte (Rückseite)"
        case "id_front":
            return "Personalausweis (Vorderseite)"
        case "id_back":
            return "Personalausweis (Rückseite)"
        case "reimbursement_declaration":
            return "Kostenübernahmeerklärung"
        case "co_payment_exemption":
            return "Zuzahlungsbefreiung"
        case "pickup_authorization":
            return "Abholvollmacht"
        case "package_documentation":
            return "Verpackungsdokumentation"
        case "pickup_confirmation":
            return "Empfangsbestätigung"
        case "other":
            return "Sonstiges"
    }

    return "Unbekannt"
}

export function $orderState(order: Pick<Order, "state" | "paymentReceived">): string {
    const stateMap: Record<string, string> = {
        new: "Neue Bestellung",
        accepted: "Angenommene Bestellung",
        verification: "Aufträge in Bearbeitung",
        manufacturing: "Aufträge zur Herstellung",
        packaging: "Aufträge zur Verpackung",
        waiting_for_release: "Aufträge zur Freigabe",
        ready_for_pickup: "Bereit für Pick-Up",
        ready_for_shipping: "Bereit für Versand",
        completed: order.paymentReceived ? "Abgeschlossen" : "Abgeschlossen (nicht bezahlt)",
        cancelled: "Storniert (durch Kunde)",
        reservation_exceeded: "Reservierungsdauer überschritten",
        rejected: "Abgelehnt",
        // verification: "Offen",
        // ready: "Bereit für Abfertigung",
        // cancelled: "Abgebrochen",
        // completed: "Abgeschlossen",
        // shipped_not_paid: "Verschickt, Zahlung ausstehend",
        // rejected: "Abgelehnt",
    }
    return stateMap[order.state ?? ""] ?? "Unbekannt"
    // let status = stateMap[order.state ?? ""] ?? "Unbekannt"
    //
    // if (order.state === "verification" && detailed) {
    //     const blocker = []
    //
    //     if (!order.paymentReceived) {
    //         blocker.push("Zahlung")
    //     }
    //
    //     if (!order.reviewed) {
    //         blocker.push("Prüfung")
    //     }
    //
    //     if (!order.prescriptionChecked && !order.isPrescriptionNotRequired) {
    //         blocker.push("Rezept")
    //     }
    //     if (blocker.length > 0) {
    //         status += " (" + blocker.join(", ") + ")"
    //     }
    // }
    // if (order.state === "ready" && detailed) {
    //     const blocker = []
    //     if (!order.paymentReceived) {
    //         blocker.push("Zahlung ausstehend")
    //     }
    //     if (blocker.length > 0) {
    //         status += " (" + blocker.join(", ") + ")"
    //     }
    // }
    //
    // return status
}

/**
 * @deprecated Use $shippingMethod from @/model/display-names instead.
 */
export const $deliveryMethod = $shippingMethod

/**
 * @deprecated Use $paymentMethod from @/model/display-names instead.
 */
export const $paymentProvider = $paymentMethod

export function $prescriptionTransmission(id: string): string {
    const names: Record<string, string> = {
        "paper/letter": "Papier, per Brief",
        "paper/letter-doctor": "Papier, per Brief vom Arzt",
        "paper/in-person": "Papier, persönliche Abgabe",
        "digital/token": "E-Rezept, per Token",
        "digital/app": "E-Rezept, per App",
        "digital/kim": "E-Rezept, per KIM",
        "digital/health-card": "E-Rezept, per Gesundheitskarte",
        "email/link": "E-Mail, per Link",
        "email/encrypted": "E-Mail, verschlüsselt",
    }

    return names[id] ?? id
}

export function $colorCategory(price: number) {
    // CAN-365
    if (price < 700) {
        return "blue"
    }
    if (price < 900) {
        return "green"
    }
    if (price < 1100) {
        return "yellow"
    }
    return "purple"
}

export function $colorCategoryWord(price: number) {
    const color = $colorCategory(price)

    switch (color) {
        case "blue":
            return "Blue"
        case "green":
            return "Green"
        case "yellow":
            return "Yellow"
        case "purple":
            return "Purple"
    }
}
